import { DELETE } from 'common/helpers.ts';
import useSWRMutation from 'swr/mutation';

export const useDeleteDocument = (documentId: string) => {
  const deleteDocumentMutation = useSWRMutation([`/document/${documentId}`], DELETE);

  return {
    deleteDocument: deleteDocumentMutation.trigger,
    isDeleting: deleteDocumentMutation.isMutating,
    error: deleteDocumentMutation.error,
    isSuccess: !deleteDocumentMutation.error && deleteDocumentMutation.data !== undefined,
  };
};

export default useDeleteDocument;
